import React, { useState } from 'react';
import { Input, Form, Button, Space } from "antd";
import { useSelector, useDispatch } from 'react-redux';
import { update_profile } from '@/redux/api';
import { UserProfileAvatar } from './UserProfileAvatar';
import AuthActions from '@/redux/auth/actions';
import styled from 'styled-components';

const ProfileFormWrapper = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: 190px minmax(0, 1fr);
    gap: 28px;
    align-items: flex-start;

    .profile-avatar-form {
        margin: 0;
    }

    .profile-avatar-panel {
        display: flex;
        justify-content: center;
        margin-top: -128px;
    }

    .profile-avatar-field {
        margin-bottom: 0;
    }

    .profile-avatar-field .ant-form-item-control-input-content {
        display: flex;
        justify-content: center;
    }

    .profile-form-panel {
        min-width: 0;
    }

    .profile-form-toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 22px;
    }

    .profile-form-toolbar .ant-space {
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .profile-form-toolbar .ant-btn {
        min-width: 88px;
        height: 38px;
        border-radius: 6px;
    }

    .profile-form {
        max-width: 640px;
    }

    .profile-form .ant-form-item {
        margin-bottom: 20px;
    }

    .profile-form .ant-form-item-label {
        flex: 0 0 132px;
        max-width: 132px;
        text-align: left;
    }

    .profile-form .ant-form-item-label > label {
        color: #64748b;
        font-weight: 500;
    }

    .profile-form .ant-form-item-control {
        min-width: 0;
    }

    .profile-readonly-value {
        min-height: 32px;
        display: flex;
        align-items: center;
        color: #1f2937;
        font-weight: 500;
        overflow-wrap: anywhere;
    }

    .profile-form .ant-input {
        height: 38px;
        border-radius: 6px;
    }

    @media only screen and (max-width: 767px) {
        display: block;

        .profile-avatar-form {
            margin-bottom: 16px;
            padding: 16px;
            border: 1px solid #eef1f5;
            border-radius: 8px;
            background: #f8fafc;
        }

        .profile-avatar-panel {
            margin-top: 0;
            margin-bottom: 0;
        }

        .profile-form-toolbar {
            margin-bottom: 18px;
        }

        .profile-form-toolbar,
        .profile-form-toolbar .ant-space,
        .profile-form-toolbar .ant-btn {
            width: 100%;
        }

        .profile-form-toolbar .ant-space {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
        }

        .profile-form-toolbar .ant-space-item {
            width: 100%;
        }

        .profile-form {
            max-width: none;
        }

        .profile-form .ant-form-item {
            display: block;
            margin-bottom: 16px;
        }

        .profile-form .ant-form-item-label {
            flex: none;
            max-width: none;
            padding: 0 0 6px;
            text-align: left;
        }

        .profile-form .ant-form-item-label > label {
            height: auto;
            font-size: 13px;
        }

        .profile-form .ant-form-item-control {
            width: 100%;
        }

        .profile-readonly-value {
            min-height: 40px;
            padding: 0 12px;
            border: 1px solid #eef1f5;
            border-radius: 6px;
            background: #f8fafc;
        }

        .profile-form .ant-input {
            height: 40px;
        }
    }
`;

const UserProfileForm = () => {

    const Auth = useSelector(state => state.Auth);
    const dispatch = useDispatch();

    const [form] = Form.useForm();
    const [isEdit, setIsEdit] = useState(false);

    const onEdit = () => {
        form.setFieldsValue({
            ...Auth,
            username: Auth.user
        });
        setIsEdit(true);
    }

    const onCancel = () => {
        form.setFieldsValue({})
        setIsEdit(false);
    }

    const onSave = async () => {
        form.validateFields().then(values => {
            const {
                username,
                email,
                first_name,
                last_name,
            } = values;

            update_profile(Auth.userId, {
                username,
                email,
                first_name,
                last_name,
            }, true).then(res => {
                if(res.status === 200) {
                    const data = res.data;

                    const {
                        username,
                        email,
                        first_name,
                        last_name,
                    } = data;

                    dispatch(AuthActions.userUpdate({
                        user: username,
                        email: email,
                        first_name: first_name,
                        last_name: last_name,
                    }));
                }
                onCancel()
            })
        })
    }


    return (

        <ProfileFormWrapper>
            <Form className="profile-avatar-form" autoComplete="off">
                <Form.Item className="profile-avatar-field">
                    <div className="profile-avatar-panel">
                        <UserProfileAvatar />
                    </div>
                </Form.Item>
            </Form>
            <div className="profile-form-panel">
            <div className="profile-form-toolbar">
                {isEdit ? <Space>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button type='primary' onClick={onSave}>Save</Button>
                </Space> : <Button type='primary' onClick={onEdit}>Edit</Button>}
            </div>
            <Form form={form} className="profile-form" autoComplete="off">
                <Form.Item label="User Name" name="username" rules={[{ required: true, message: 'Please enter your user name' }]}>
                    {/* {isEdit ? <Input /> : Auth.user} */}
                    <span className="profile-readonly-value">{Auth.user || '-'}</span>
                </Form.Item>
                <Form.Item label="Email" name="email" rules={[{ 
                    pattern: /^[a-zA-Z0-9.+]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,63}$/,
                    message: 'Email can only contain letters (a-z), numbers (0-9), dots (.), and plus signs (+)'
                }]}>
                    {isEdit ? <Input /> : <span className="profile-readonly-value">{Auth.email || '-'}</span>}
                </Form.Item>
                <Form.Item label="First Name" name="first_name" rules={[{ required: true, message: 'Please enter your first name' }]}>
                    {isEdit ? <Input /> : <span className="profile-readonly-value">{Auth.first_name || '-'}</span>}
                </Form.Item>
                <Form.Item label="Last Name" name="last_name" rules={[{ required: true, message: 'Please enter your last name' }]}>
                    {isEdit ? <Input /> : <span className="profile-readonly-value">{Auth.last_name || '-'}</span>}
                </Form.Item>
            </Form>
            </div>

        </ProfileFormWrapper>


    )
}

export default UserProfileForm;
